export default __webpack_public_path__ + "static/media/964.72281ecd.gif";